<template lang="pug">
  div.invoice-control
    e-modal(
      ref="modalForm"
      @confirm="sendForm()"
      @close="closeForm()"
      title="Загрузка выписки"
      saveBtnLabel="Загрузить"
      :hideDeleteButton="false"
      :centered="true"
      :autoHeight="true"
    )
      slot
        e-form(
          :formValidator="formValidator"
          :enablePerfectScrollbar="false"
          formClass="fix-elements-overflow-problem"
        )
          div.body
            div.col
              e-form-group(
                name="file"
                inputType="simple-file-uploader"
                label="Файл"
                :model="fields"
                tabView="tab1"
                :required="true"
                uploadType="attachToForm"
              ).no-min-height
</template>

<script>
  import {invoiceControl} from '../../api/api-endpoints.js'
  import formBaseMixin from '../../components/form/form-base-mixin.js'

  export default {
    mixins: [formBaseMixin],
    methods: {
      closeForm () {
        this.$refs.modalForm.redirectToPrev()
      },
      getUpdateOrCreateUrl () {
        return invoiceControl.bankStatementCreate()
      },
      /**
       * @override
       * @param fields
       * @returns {FormData}
       */
      getAsFormData (fields) {
        const fd = new FormData()
        fd.append('file', fields.file.file)
        return fd
      },
      /**
       * @override
       */
      getSuccessTitle () {
        return null
      }
    }
  }
</script>
